import { SortOrder } from '../sort-order';

export class DeviceRemovedFilters {
  serialNumber: string;
  rangeDates: number[];
  sortField: string;
  sortOrder: SortOrder;
  tenantUuids: string[];
  organizationUuids: string[];
}
